import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { Groups as GroupsIcon, Search as SearchIcon, Description as PostIcon, Warning as WarningIcon } from '@mui/icons-material';

const KPIStrip = ({
  totalClients = 0,
  clientsWithKeywords = 0,
  clientsWithPosts = 0,
  actionRequired = 0
}) => {
  const keywordPercent = totalClients > 0 ? Math.round((clientsWithKeywords / totalClients) * 100) : 0;
  const postPercent = totalClients > 0 ? Math.round((clientsWithPosts / totalClients) * 100) : 0;
  const actionPercent = totalClients > 0 ? Math.round((actionRequired / totalClients) * 100) : 0;

  const kpiCards = [
    {
      label: 'Kunden gesamt',
      value: totalClients,
      detail: `+6 in den letzten 7 Tagen`,
      bgColor: '#FFFFFF',
      borderColor: '#ECEBEE',
      textColor: '#0A0A0B',
      detailColor: '#55555D',
      icon: <GroupsIcon sx={{ fontSize: 28, color: '#999999', opacity: 0.3 }} />
    },
    {
      label: 'Mit Keywords',
      value: clientsWithKeywords,
      detail: `${keywordPercent}% abgedeckt`,
      detailColor: '#1E9E5A',
      bgColor: '#FFFFFF',
      borderColor: '#ECEBEE',
      textColor: '#0A0A0B',
      icon: <SearchIcon sx={{ fontSize: 28, color: '#1E9E5A', opacity: 0.3 }} />
    },
    {
      label: 'Mit Posts',
      value: clientsWithPosts,
      detail: `${postPercent}% abgedeckt`,
      detailColor: '#1E9E5A',
      bgColor: '#FFFFFF',
      borderColor: '#ECEBEE',
      textColor: '#0A0A0B',
      icon: <PostIcon sx={{ fontSize: 28, color: '#1E9E5A', opacity: 0.3 }} />
    },
    {
      label: 'Handlungsbedarf',
      value: actionRequired,
      detail: `${actionPercent}% des Portfolios`,
      bgColor: `linear-gradient(180deg, #FDF2F4 0%, #FFFFFF 100%)`,
      borderColor: '#FBE0E5',
      textColor: '#C80F2E',
      detailColor: '#C80F2E',
      icon: <WarningIcon sx={{ fontSize: 28, color: '#C80F2E', opacity: 0.3 }} />
    }
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '16px',
        mb: 3
      }}
    >
      {kpiCards.map((card, idx) => (
        <Card
          key={idx}
          sx={{
            background: card.bgColor,
            border: `1px solid ${card.borderColor}`,
            borderRadius: '14px',
            padding: '20px 18px',
            boxShadow: '0 1px 2px rgba(16,16,20,.06), 0 2px 6px rgba(16,16,20,.05)',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            position: 'relative'
          }}
        >
          {/* Icon in Top Right */}
          <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
            {card.icon}
          </Box>

          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 600,
              color: '#55555D',
              fontFamily: 'Plus Jakarta Sans, system-ui'
            }}
          >
            {card.label}
          </Typography>

          <Typography
            sx={{
              fontSize: '40px',
              fontWeight: 700,
              color: card.textColor,
              fontFamily: 'JetBrains Mono, monospace',
              lineHeight: 1.1,
              margin: 0
            }}
          >
            {card.value}
          </Typography>

          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              color: card.detailColor,
              fontFamily: 'Plus Jakarta Sans, system-ui'
            }}
          >
            {card.detail}
          </Typography>
        </Card>
      ))}
    </Box>
  );
};

export default KPIStrip;
